import { getAction, postAction } from '@/utils/http.js'//引入封装的get post方法

//应用方案
const application = (params)=>getAction("/api/official/website/application/list",params);
//方案详情
const applicationDetail = (params)=>getAction("/api/official/website/common/getArticleById",params);
export {
    application,
    applicationDetail,
}